import type { ListNotificationsFragment } from "@/gql/graphql";
import { ApprovalStatus } from "@/gql/graphql";
import { useApprovalDeclinedStore } from "@/store/useApprovalDeclinedStore";

const SUPPORTED_APPROVAL_STATUSES = new Set<ApprovalStatus>([
  ApprovalStatus.Rejected,
  ApprovalStatus.Approved,
]);

type ApprovalNotificationData = Extract<
  NonNullable<ListNotificationsFragment["data"]>,
  { __typename: "ContractApprovalStatusNotification" }
>;

export function handleApprovalStatusNotification(
  data: ApprovalNotificationData
): boolean {
  if (
    !SUPPORTED_APPROVAL_STATUSES.has(data.approvalStatus) ||
    !data.contractId ||
    !data.approvalRequestType
  ) {
    return false;
  }

  useApprovalDeclinedStore
    .getState()
    .setApprovalStatus(
      data.contractId,
      data.approvalRequestType,
      data.approvalStatus
    );

  return true;
}
